// PostHog events for the onboarding wizard.
// Step completions are not sent from here: the backend `$set` on onboarded_steps_completed
// covers them.
import { trackEvent } from './analytics';

const STEP_NAMES = ['welcome', 'connect_accounts', 'steam_bot', 'match_history', 'subscription', 'play_now'];

export function onboardingStepName(step) {
  return STEP_NAMES[step] || `step_${step}`;
}

// Step 4 shows FreeTrialPage or SubscribePage under one step number (see OnboardingPage.vue).
export function onboardingStepVariant(step, { trialCookie, overwriteTrialCookie }) {
  if (step !== 4) return null;
  return trialCookie && !overwriteTrialCookie ? 'free_trial' : 'subscribe';
}

export function trackOnboarding(name, props) {
  trackEvent(name, { ...props, wizard_version: 1 });
}
